export default __webpack_public_path__ + "static/media/trois.2a39e15b.jpg";